module.exports = __webpack_public_path__ + "img/get-app-ph.7b42a68.png";